module.exports = __webpack_public_path__ + "static/archie_logo_white-2c7890188c23302cc419186b66a29d2e.png";